// extracted by mini-css-extract-plugin
export default {"chats":"Chats_chats__Cky7h","-mobile":"Chats_-mobile__EX1YC","base":"Chats_base__1LKca","header":"Chats_header__PXYSz","controls":"Chats_controls__AZXqQ"};